import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { dictionaries } from "@/i18n/dictionaries";
import { translateString } from "@/i18n/translate";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("astro_lang") || "en");

  useEffect(() => {
    localStorage.setItem("astro_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (path) => {
      const dict = dictionaries[lang] || dictionaries.en;
      const val = path.split(".").reduce((o, k) => (o ? o[k] : undefined), dict);
      if (val != null) return val;
      // fallback to English
      return path.split(".").reduce((o, k) => (o ? o[k] : undefined), dictionaries.en) ?? path;
    },
    [lang],
  );

  const tr = useCallback((en) => translateString(en, lang), [lang]);

  return <LanguageContext.Provider value={{ lang, setLang, t, tr }}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);
